import { Button } from '@mui/material';
import { Link, useHistory, useParams } from 'react-router-dom';

import { RouterParams } from 'containers/AppRouter';
import TableRender, { RenderBoolean, TableRenderFieldT } from 'shared/components/Table/TableRender';
import { UserT } from 'shared/models/users';
import api, { APIInterfaceWithActiveStatusI } from 'utils/api';
import { datePrettyDisplay, formatDateFromNow } from 'utils/date';

export const URLOrganizationPrefix = (organizationName?: string) => (
  organizationName ? `/organizations/${organizationName}` : ''
);

function GenericUsers() {
  const { organizationName } = useParams() as RouterParams;
  const history = useHistory();

  const apiCall = organizationName ? new api.OrganizationUsers(organizationName) : api.users;

  const goToSourceID = (username: string) => {
    history.push(`${URLOrganizationPrefix(organizationName)}/users/${username}`);
  };

  const fields: TableRenderFieldT[] = [
    {
      displayName: 'Username',
      renderFn: (row: UserT) => row.username,
      align: 'center',
    },
    {
      displayName: 'Name',
      renderFn: (row: UserT) => `${row.firstname} ${row.lastname}`.trim(),
      align: 'center',
    },
    {
      displayName: 'E-mail',
      renderFn: (row: UserT) => row.email,
      align: 'center',
    },
    {
      displayName: 'Phone',
      renderFn: (row: UserT) => row.phone,
      align: 'center',
    },
    {
      displayName: 'Last Login',
      renderFn: (row: UserT) => (row.lastLogin ? formatDateFromNow(row.lastLogin) : 'Never'),
      tooltipFn: (row: UserT) => (row.lastLogin ? datePrettyDisplay(row.lastLogin) : ''),
      align: 'center',
    },
    {
      displayName: 'Admin',
      renderFn: (row: UserT) => RenderBoolean(row.admin, 'icon'),
      align: 'center',
    },
    {
      displayName: 'Active',
      renderFn: (row: UserT) => RenderBoolean(row.active, 'icon'),
      align: 'center',
    },
  ];

  return (
    <>
      <div className="title__header">
        <div className="title__header--block">
          {
            organizationName
              ? <h2>Manage organization users</h2>
              : <h1>Users</h1>
          }
        </div>
        <Link to={`${URLOrganizationPrefix(organizationName)}/users/create`}>
          <Button variant="contained" color="secondary" size="small">Create</Button>
        </Link>
      </div>
      <TableRender
        api={apiCall as APIInterfaceWithActiveStatusI}
        renderFields={fields}
        onClickRow={(row: UserT) => goToSourceID(row.username)}
        hasNoPagination
      />
    </>
  );
}

export default GenericUsers;
